import React from 'react'
import { Link } from 'react-router-dom'
import slider2 from '../../../../../assets/img/work_face.webp'

function WorkforceManagementsec1() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li>
               <li><Link to='/product'>Product</Link></li>
               <li>Workforce Management</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Workforce <span>Management</span></h2>
              <p>Welcome to <b>Workface</b> - Your Trusted Partner in <b>Business Process Automation</b> and <b>Workforce Management.</b></p>
              <p>Workface is a cutting-edge software solution developed by <b>360 Bytes</b>, designed to revolutionize workforce management. We understand the complexities of running an organization, which is why our software is designed to integrate seamlessly with your existing ERP systems, enhancing efficiency across multiple domains.</p>
              <p>With its intuitive interface and advanced features, Workface streamlines employee scheduling, attendance tracking, and operational workflows, making it an essential tool for businesses of all sizes. </p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider2} alt='' loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default WorkforceManagementsec1
